import React, { useEffect, useState } from 'react';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { Modal, notification } from 'antd';
import { getEntities as getKrCheckIn, reset } from 'app/entities/checkIn/checkIn.reducer';
import { getBoxWorkStatus } from 'app/entities/common/common.reducer';
import { KrTypes } from 'app/shared/model/enum/kr.enum';
import ReportQualitativeResult from './reportQualitativeResult';
import ReportQuantitativeResult from './reportQuantitativeResult';

type IReportQualitativeResult = {
  isOpen: boolean;
  onClose: (isReload?: boolean) => void;
  krSelected?: any;
};

export const ReportKr = ({ isOpen, onClose, krSelected }: IReportQualitativeResult) => {
  const dispatch = useAppDispatch();

  const checkInList = useAppSelector(state => state.checkIn.entities);
  const filters = useAppSelector(state => state.filters.orgCheckIn);

  const [krReportInfo, setKrReportInfo] = useState<any>(krSelected);
  const [isNextKr, setNextKr] = useState(false);

  const handleClose = (isReload = undefined) => {
    dispatch(reset());
    onClose(isReload ?? isNextKr);
  };

  useEffect(() => {
    dispatch(getBoxWorkStatus({ statusType: 1 }));
    if (filters?.planPeriodId && !krSelected) innitData();
  }, [filters, krSelected]);

  useEffect(() => {
    if (checkInList) {
      if (checkInList.length <= 0) {
        notification.warning({ message: 'Tất cả các KR đã được check in', placement: 'topLeft' });
        handleClose();
        return;
      }
      else if (!krSelected)
        setKrReportInfo(checkInList[0]);
    }
  }, [checkInList]);

  const innitData = () => {
    setNextKr(true);
    dispatch(getKrCheckIn({ planPeriodId: filters?.planPeriodId, checkinType: 0, partyId: filters?.accountableId }));
  };

  const handleNext = () => {
    innitData();
  };

  return krReportInfo ? (
    <Modal
      width={1300} // Full width
      open={isOpen}
      maskClosable={false}
      footer={null}
      onCancel={() => {
        handleClose();
      }}
    >
      {krReportInfo?.krType === KrTypes.Qualitative ? (
        <ReportQualitativeResult hideNextKr={krSelected !== null ? true : false} krCheckIn={krReportInfo} handleNextData={handleNext} handleClose={handleClose} />
      ) : (
        <ReportQuantitativeResult hideNextKr={krSelected !== null ? true : false} krCheckIn={krReportInfo} handleNextData={handleNext} handleClose={handleClose} />
      )}
    </Modal>
  ) : undefined;
};

export default ReportKr;
